import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminExport',
  props: {
  portfolioId: {
    type: String,
    required:false
  },
},
  setup(__props) {



return { __sfc: true, }
}

})